function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import styled from 'styled-components';
import { string, number, node, shape, bool } from 'prop-types';
import VisuallyHiddenText from '@bbc/psammead-visually-hidden-text';
import { GEL_GROUP_0_SCREEN_WIDTH_MAX, GEL_GROUP_2_SCREEN_WIDTH_MIN, GEL_GROUP_3_SCREEN_WIDTH_MIN, GEL_GROUP_5_SCREEN_WIDTH_MIN } from '@bbc/gel-foundations/breakpoints';
import { GEL_SPACING_HLF, GEL_SPACING, GEL_SPACING_DBL } from '@bbc/gel-foundations/spacings';
var SVG_TOP_OFFSET_BELOW_400PX = '0.625rem'; // 10px

var SVG_BOTTOM_OFFSET_BELOW_400PX = '0.375rem'; // 6px

var SVG_BOTTOM_OFFSET_ABOVE_400PX = '0.75rem'; // 12px

var SVG_BOTTOM_OFFSET_ABOVE_600PX = '1.25rem'; // 20px

var SCRIPT_LINK_OFFSET_BELOW_240PX = 52;
var PADDING_AROUND_SVG_BELOW_400PX = 16;
var PADDING_AROUND_SVG_ABOVE_400PX = 28;

var conditionallyRenderHeight = function conditionallyRenderHeight(svgHeight, padding) {
  return svgHeight ? "min-height: ".concat((svgHeight + padding) / 16, "rem;") : '';
};

var TRANSPARENT_BORDER = "0.0625rem solid transparent";
var SvgWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "SvgWrapper",
  componentId: "m3awbo-0"
})(["position:relative;display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;max-width:", ";margin:0 auto;@media (max-width:", "){display:block;}"], GEL_GROUP_5_SCREEN_WIDTH_MIN, GEL_GROUP_0_SCREEN_WIDTH_MAX);
var Banner = /*#__PURE__*/styled.div.withConfig({
  displayName: "Banner",
  componentId: "m3awbo-1"
})(["background-color:", ";", " width:100%;padding:0 ", ";@media (min-width:", "){", " padding:0 ", ";}@media (max-width:", "){", "}border-top:", ";border-bottom:", ";"], function (props) {
  return props.backgroundColour;
}, function (_ref) {
  var svgHeight = _ref.svgHeight;
  return conditionallyRenderHeight(svgHeight, PADDING_AROUND_SVG_BELOW_400PX);
}, GEL_SPACING, GEL_GROUP_2_SCREEN_WIDTH_MIN, function (_ref2) {
  var svgHeight = _ref2.svgHeight;
  return conditionallyRenderHeight(svgHeight, PADDING_AROUND_SVG_ABOVE_400PX);
}, GEL_SPACING_DBL, GEL_GROUP_0_SCREEN_WIDTH_MAX, function (_ref3) {
  var scriptLink = _ref3.scriptLink,
      svgHeight = _ref3.svgHeight;
  return scriptLink && "min-height: ".concat((svgHeight + PADDING_AROUND_SVG_BELOW_400PX + SCRIPT_LINK_OFFSET_BELOW_240PX) / 16, "rem;");
}, function (_ref4) {
  var borderTop = _ref4.borderTop;
  return borderTop && TRANSPARENT_BORDER;
}, function (_ref5) {
  var borderBottom = _ref5.borderBottom;
  return borderBottom && TRANSPARENT_BORDER;
});

var brandWidth = function brandWidth(minWidth, maxWidth) {
  return "\n  width: 100%;\n  max-width: ".concat(maxWidth / 16, "rem;\n  min-width: ").concat(minWidth / 16, "rem;\n  flex: 1 1 ").concat(minWidth / 16, "rem;\n  -ms-flex-preferred-size: ").concat(maxWidth / 16, "rem;\n");
};

var StyledLink = /*#__PURE__*/styled.a.withConfig({
  displayName: "StyledLink",
  componentId: "m3awbo-2"
})(["display:inline-block;", " @media (max-width:", "){display:block;}"], function (_ref6) {
  var maxWidth = _ref6.maxWidth,
      minWidth = _ref6.minWidth;
  return brandWidth(minWidth, maxWidth);
}, GEL_GROUP_0_SCREEN_WIDTH_MAX); // `currentColor` has been used to address high contrast mode in Firefox.

var BrandSvg = /*#__PURE__*/styled.svg.withConfig({
  displayName: "BrandSvg",
  componentId: "m3awbo-3"
})(["box-sizing:content-box;color:", ";fill:currentColor;padding-top:", ";padding-bottom:", ";height:", "rem;", " @media (min-width:", "){padding-top:", ";padding-bottom:", ";}@media (min-width:", "){padding-top:", ";padding-bottom:", ";}@media screen and (-ms-high-contrast:active),print{fill:windowText;}", ":hover &,", ":focus &{text-decoration:none;border-bottom:", " solid ", ";margin-bottom:-", ";}"], function (props) {
  return props.logoColour;
}, SVG_TOP_OFFSET_BELOW_400PX, SVG_BOTTOM_OFFSET_BELOW_400PX, function (props) {
  return props.height / 16;
}, function (_ref7) {
  var maxWidth = _ref7.maxWidth,
      minWidth = _ref7.minWidth;
  return brandWidth(minWidth, maxWidth);
}, GEL_GROUP_2_SCREEN_WIDTH_MIN, GEL_SPACING_DBL, SVG_BOTTOM_OFFSET_ABOVE_400PX, GEL_GROUP_3_SCREEN_WIDTH_MIN, SVG_BOTTOM_OFFSET_ABOVE_600PX, GEL_SPACING_DBL, StyledLink, StyledLink, GEL_SPACING_HLF, function (props) {
  return props.logoColour;
}, GEL_SPACING_HLF);

var LocalisedBrandName = function LocalisedBrandName(_ref8) {
  var product = _ref8.product,
      serviceLocalisedName = _ref8.serviceLocalisedName;
  return serviceLocalisedName ?
  /*#__PURE__*/
  // eslint-disable-next-line jsx-a11y/aria-role
  React.createElement(VisuallyHiddenText, {
    role: "text"
  }, /*#__PURE__*/React.createElement("span", {
    lang: "en-GB"
  }, product), ", ", serviceLocalisedName) : /*#__PURE__*/React.createElement(VisuallyHiddenText, null, product);
};

LocalisedBrandName.propTypes = {
  product: string.isRequired,
  serviceLocalisedName: string
};
LocalisedBrandName.defaultProps = {
  serviceLocalisedName: null
};

var StyledBrand = function StyledBrand(_ref9) {
  var product = _ref9.product,
      serviceLocalisedName = _ref9.serviceLocalisedName,
      svgHeight = _ref9.svgHeight,
      svg = _ref9.svg,
      maxWidth = _ref9.maxWidth,
      minWidth = _ref9.minWidth,
      backgroundColour = _ref9.backgroundColour,
      logoColour = _ref9.logoColour;
  return /*#__PURE__*/React.createElement(React.Fragment, null, svg && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BrandSvg, {
    height: svgHeight,
    viewBox: "0 0 ".concat(svg.viewbox.width, " ").concat(svg.viewbox.height),
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true",
    ratio: svg.ratio,
    maxWidth: maxWidth,
    minWidth: minWidth,
    backgroundColour: backgroundColour,
    logoColour: logoColour
  }, svg.group), /*#__PURE__*/React.createElement(LocalisedBrandName, {
    product: product,
    serviceLocalisedName: serviceLocalisedName
  })));
};

var brandProps = {
  product: string.isRequired,
  serviceLocalisedName: string,
  maxWidth: number.isRequired,
  minWidth: number.isRequired,
  svgHeight: number.isRequired,
  svg: shape({
    group: node.isRequired,
    ratio: number.isRequired,
    viewbox: shape({
      height: number.isRequired,
      width: number.isRequired
    }).isRequired
  }).isRequired,
  backgroundColour: string.isRequired,
  logoColour: string.isRequired
};
StyledBrand.propTypes = brandProps;
StyledBrand.defaultProps = {
  serviceLocalisedName: null
};

var Brand = function Brand(props) {
  var svgHeight = props.svgHeight,
      maxWidth = props.maxWidth,
      minWidth = props.minWidth,
      url = props.url,
      borderTop = props.borderTop,
      borderBottom = props.borderBottom,
      backgroundColour = props.backgroundColour,
      logoColour = props.logoColour,
      scriptLink = props.scriptLink,
      skipLink = props.skipLink,
      rest = _objectWithoutProperties(props, ["svgHeight", "maxWidth", "minWidth", "url", "borderTop", "borderBottom", "backgroundColour", "logoColour", "scriptLink", "skipLink"]);

  return /*#__PURE__*/React.createElement(Banner, _extends({
    svgHeight: svgHeight,
    borderTop: borderTop,
    borderBottom: borderBottom,
    backgroundColour: backgroundColour,
    logoColour: logoColour,
    scriptLink: scriptLink
  }, rest), /*#__PURE__*/React.createElement(SvgWrapper, null, url ? /*#__PURE__*/React.createElement(StyledLink, {
    href: url,
    maxWidth: maxWidth,
    minWidth: minWidth
  }, /*#__PURE__*/React.createElement(StyledBrand, props)) : /*#__PURE__*/React.createElement(StyledBrand, props), skipLink, scriptLink && /*#__PURE__*/React.createElement("div", null, scriptLink)));
};

Brand.defaultProps = {
  url: null,
  serviceLocalisedName: null,
  borderTop: false,
  borderBottom: false,
  scriptLink: null,
  skipLink: null
};
Brand.propTypes = _objectSpread(_objectSpread({}, brandProps), {}, {
  url: string,
  serviceLocalisedName: string,
  borderTop: bool,
  borderBottom: bool,
  scriptLink: node,
  skipLink: node
});
export default Brand;